import React, { useEffect, useMemo, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import LockIcon from "@mui/icons-material/Lock";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";

import { Loader } from "../../common/loader";
import DialogBox from "../../common/DialogBox";
import { ROLES } from "../../helpers/constants";
import AlertDialog from "../../common/AlertDialog";
import CountyListDropDown from "../../common/CountyListDropDown";
import { brokerAgentsAction } from "../../../redux/slices/brokers";
import SubscriptionPlansContent from "../../common/SubscriptionPlans";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";
import SubscriptionPlansFeatures from "../../common/SubscriptionPlansFeatures";
import TotalPyamentPopup from "../../user-signup/React-stripe/TotalPyamentPopup";
import {
  decryptPayload,
  findAllowedPrefixData,
  getObjLength,
  isServicerAddPropertyCheckout,
  resolveEnhancedMonitoringReportIds,
} from "../../helpers/utils";
import { attachEnhancedToCompleteUpgradeFlags } from "../../helpers/generatePropertySecurityQuestions";
import {
  clearEldoradoAdminEnhancedBillingChoice,
  complimentaryEnhancedFreeFlagPayload,
  isAdminEldoradoComplimentaryEnhancedSelected,
  isLoggedInSuperOrInternalAdmin,
} from "../../helpers/eldoradoSignup";
import InvestorsAnnaulSubscriptionPlan from "../../common/investorsAnnaulSubscriptionPlan";
import SubscriptionPlansTailwind from "./SubscriptionPlansTailwind";
import { mapCreateUserApiUrl } from "../../for-service-provider/createUserApiPaths";
import {
  isCarAddPropertyClient,
  readCarPortfolioIds,
  rememberCarPortfolioIds,
} from "../../for-service-provider/carPortfolioStatus";
import { postAPIPayload } from "../../../apis/postApi";
import { getAPIPayload } from "../../../apis/getApi";

// Agent ("paid_at_closing") or buyer ("buyer_at_closing") pays at closing:
// both go through the closing invoice (card 3853).
const isPayingAtClosing = (choice) =>
  choice === "paid_at_closing" || choice === "buyer_at_closing";

// car_agent_properties.payment_timing for the plans-page choice.
const paymentTimingFor = (choice) => {
  if (choice === "buyer_at_closing") return "buyer_pays_at_closing";
  return isPayingAtClosing(choice) ? "bill_at_closing" : "client_pays_now";
};

const SubscriptionPlans = ({
  onChangeModalScreen,
  planId,
  setFinalAmount,
  isAdminCreateUser = false,
  selectedData = {},
  from = "",
  uid = null,
  propertiesIds = [],
  ids = [],
  tabComponent = false,
  setSkipVerification,
  isShow = true,
  isUserCreateProperty = false,
  fromPropertyList,
  handleCloseAddPropertyModal,
  showSource = false,
  isBulkSubscription = false,
  promoCode = undefined,
  titleCompanyUser = {},
  category = "complete_protection",
  isTailwindComponent = false,
  isServiceProvider = false,
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [alert, setAlert] = useState(false);
  const [dataflag, setDataFlag] = useState(false);
  const [countyListModal, setCountyListModal] = useState(false);
  const [defaultcounty, setDefaultCountyData] = useState("EquityProtect");
  const [finalAmountRequest, setFinalAmountRequest] = useState(null);
  const dataflagRef = useRef(false);
  // Servicer-only: 5-year paid-at-closing invoice instead of a card charge.
  // Basic/enhanced monitoring are card-only, so the option never applies there.
  const servicerClosingEligible =
    isServiceProvider &&
    isAdminCreateUser &&
    category === "complete_protection";
  const readEnrollmentKind = () => {
    try {
      return JSON.parse(localStorage.getItem("carPortfolioPrefill") || "{}")
        .enrollment_kind;
    } catch {
      return "";
    }
  };
  const postCloseCardOnly = readEnrollmentKind() === "post_close";
  const [servicerPaymentChoice, setServicerPaymentChoice] = useState(
    postCloseCardOnly || !servicerClosingEligible ? "card" : "paid_at_closing",
  );
  const [carCheckDone, setCarCheckDone] = useState(false);
  const [carAgent, setCarAgent] = useState(
    () =>
      localStorage.getItem("signup_source") === "car" ||
      Boolean(localStorage.getItem("car_portfolio_id")),
  );
  const [carTerm, setCarTerm] = useState("car_5yr");
  const [revenueChoice, setRevenueChoice] = useState("keep");
  const [pocRecording, setPocRecording] = useState(false);
  const [closingQuote, setClosingQuote] = useState(null);
  const [closingQuoteLoading, setClosingQuoteLoading] = useState(false);
  const [closingQuoteError, setClosingQuoteError] = useState("");
  const [complimentaryEnrollResult, setComplimentaryEnrollResult] =
    useState(null);
  const pendingComplimentaryEnhancedRef = useRef(false);

  const userIdFromSession = localStorage.getItem("user_Id");
  // Bumped once a property added from the client page has its portfolio row.
  const [addedPortfolioRows, setAddedPortfolioRows] = useState(0);
  // Each portfolio row's type, looked up once while choosing the plan.
  const portfolioKinds = useRef({});

  const carEnrollmentFields = () => {
    if (!carAgent || !servicerClosingEligible) {
      return {};
    }
    const portfolioId = localStorage.getItem("car_portfolio_id");
    let portfolioIds = [];
    try {
      portfolioIds = JSON.parse(localStorage.getItem("car_portfolio_ids") || "[]");
    } catch {
      portfolioIds = [];
    }
    if (!Array.isArray(portfolioIds) || !portfolioIds.length) {
      portfolioIds = portfolioId ? [Number(portfolioId)] : [];
    }
    return {
      payment_plan: carTerm,
      revenue_share_choice: revenueChoice,
      ...(portfolioIds.length
        ? {
            car_agent_property_id: Number(portfolioIds[0]),
            car_agent_property_ids: portfolioIds.map(Number),
          }
        : {}),
    };
  };

  useEffect(() => {
    if (!isServiceProvider) {
      return undefined;
    }
    let cancelled = false;
    getAPIPayload({
      url: "service-provider/get-professional-details",
      data: { source: "service_provider" },
      token: true,
    }).then((response) => {
      if (!cancelled) {
        const isCar = response?.data?.signup_source === "car";
        setCarAgent(isCar);
        if (isCar) {
          localStorage.setItem("signup_source", "car");
        }
        setCarCheckDone(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [isServiceProvider]);

  useEffect(() => {
    if (!carAgent) {
      return undefined;
    }
    // Every row being paid (several when the agent picked them together).
    const portfolioIds = readCarPortfolioIds();
    if (!portfolioIds.length) {
      return undefined;
    }
    let prefill = {};
    try {
      prefill = JSON.parse(localStorage.getItem("carPortfolioPrefill") || "{}");
    } catch {
      prefill = {};
    }
    const inEscrow = prefill.enrollment_kind === "in_escrow";
    const cardOnly = readEnrollmentKind() === "post_close";
    const paymentTiming = cardOnly
      ? "client_pays_now"
      : paymentTimingFor(servicerPaymentChoice);
    // Client-pays-now saves the quote here. This runs while the agent is still
    // choosing, so it never emails the escrow officer (card 3853): pay at closing
    // emails on the invoice step, client-pays-now after the card payment.
    const saveChargeNow = inEscrow && servicerPaymentChoice === "card";
    const currentKind = prefill.enrollment_kind || "post_close";
    let cancelled = false;
    // A row of the other type (previously closed vs in escrow) keeps its own
    // answers; only rows of this type, or with none yet, get this choice.
    const sameKind = async (portfolioId) => {
      if (!(portfolioId in portfolioKinds.current)) {
        const response = await getAPIPayload({
          url: `service-provider/car-portfolio/${portfolioId}`,
          token: true,
        }).catch(() => null);
        portfolioKinds.current[portfolioId] = response?.success
          ? response.data?.enrollment_kind || null
          : null;
      }
      const kind = portfolioKinds.current[portfolioId];
      return !kind || kind === currentKind;
    };
    portfolioIds.forEach(async (portfolioId) => {
      if (!(await sameKind(portfolioId)) || cancelled) {
        return;
      }
      postAPIPayload({
        url: saveChargeNow
          ? `service-provider/car-portfolio/${portfolioId}/quote`
          : `service-provider/car-portfolio/${portfolioId}/prepare`,
        data: saveChargeNow
          ? {
              payment_plan: carTerm,
              revenue_share_choice: revenueChoice,
              payment_timing: paymentTiming,
              notify_escrow: false,
              escrow_officer_name: prefill.escrow_officer_name,
              escrow_officer_email: prefill.escrow_officer_email,
              estimated_close_of_escrow: prefill.estimated_close_of_escrow,
            }
          : {
              enrollment_kind: prefill.enrollment_kind || "post_close",
              payment_plan: carTerm,
              revenue_share_choice: revenueChoice,
              payment_timing: paymentTiming,
              escrow_officer_name: prefill.escrow_officer_name,
              escrow_officer_email: prefill.escrow_officer_email,
              estimated_close_of_escrow: prefill.estimated_close_of_escrow,
            },
        token: true,
      });
    });
    return () => {
      cancelled = true;
    };
  }, [carAgent, carTerm, revenueChoice, servicerPaymentChoice, addedPortfolioRows]);

  useEffect(() => {
    if (!isServiceProvider) {
      return;
    }
    if (!carCheckDone && !carAgent) {
      return;
    }
    if (!carAgent || !servicerClosingEligible) {
      if (carCheckDone) {
        localStorage.removeItem("carEnrollment");
      }
      return;
    }
    localStorage.setItem(
      "carEnrollment",
      JSON.stringify(carEnrollmentFields()),
    );
  }, [carAgent, carCheckDone, carTerm, revenueChoice, servicerClosingEligible, isServiceProvider, addedPortfolioRows]);
  const { propertyIds, properties, investorsID, isAnualPlanScreen, paymentData, paymnetLoader, property_ids, propertyIds: signupPropertyIds } =
    useSelector((state) => state.signUpUser);

  // store data
  const userProfileDetails = useSelector(
    (state) => state?.userProfile?.userProfileDetails,
  );
  const {
    subscriptionPlans,
    totalPaymentDetails,
    statesLoader,
    createAccResponse,
    getTotalAmountLoader,
  } = useSelector((state) => state?.signUpUser);
  const { selectedProperty, selectedUserID, propertyQuestion } = useSelector(
    (state) => state?.properties,
  );
  const selectedUserData = useSelector(
    (state) => state?.propertyUsers?.selectedProperty,
  );

  // A property the agent adds to an existing client (client page > Add
  // Property) has no portfolio row yet. Make it now, so the agent's portfolio
  // lists the property even if payment is never finished, and charge against it.
  useEffect(() => {
    if (!carAgent || !isServiceProvider) {
      return undefined;
    }
    if (localStorage.getItem("car_portfolio_id")) {
      return undefined;
    }
    const clientUserId = selectedUserID || uid;
    const kind = readEnrollmentKind();
    // In escrow only from the Add Property steps for this client (card 3854).
    const addPropertyInEscrow =
      kind === "in_escrow" && isCarAddPropertyClient(clientUserId);
    if (kind !== "post_close" && !addPropertyInEscrow) {
      return undefined;
    }
    // Only the property chosen in this Add Property flow. The stored signup list
    // can still hold properties from an earlier flow, which already have their
    // own row and type.
    const parcels = [selectedProperty?.property_id].filter(Boolean);
    if (!clientUserId || !parcels.length) {
      return undefined;
    }
    let prefill = {};
    try {
      prefill = JSON.parse(localStorage.getItem("carPortfolioPrefill") || "{}");
    } catch {
      prefill = {};
    }
    let cancelled = false;
    postAPIPayload({
      url: "service-provider/car-portfolio/added-property",
      data: {
        client_user_id: clientUserId,
        property_ids: parcels,
        enrollment_kind: kind,
        ...(addPropertyInEscrow
          ? {
              escrow_officer_name: prefill.escrow_officer_name,
              escrow_officer_email: prefill.escrow_officer_email,
              estimated_close_of_escrow: prefill.estimated_close_of_escrow,
            }
          : {}),
      },
      token: true,
    }).then((response) => {
      const ids = response?.data?.ids || [];
      if (cancelled || !response?.success || !ids.length) {
        return;
      }
      rememberCarPortfolioIds(ids);
      setAddedPortfolioRows((count) => count + 1);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carAgent, isServiceProvider, selectedUserID, uid, selectedProperty?.property_id]);

  const { servicerProfessionalDetails } = useSelector(
    (state) => state?.servicerProfile,
  );

  const isNormalCustomer = decryptPayload(
    localStorage.getItem("roles"),
  )?.includes(ROLES.customer);
  const findTitleCompanyUser =
    defaultcounty !== "EquityProtect"
      ? findAllowedPrefixData(defaultcounty)
      : null;

  const isAssistantAccount =
    decryptPayload(localStorage?.getItem("agent_role")) === ROLES?.assistant;
  const isSignupCompleted =
    from === "add-subscriptions" && !isBulkSubscription
      ? selectedData?.owner?.[0]?.json_last_step?.step_key ===
        "SEND_WELCOME_EMAIL"
      : selectedData?.json_last_step?.step_key === "SEND_WELCOME_EMAIL";

  const isFirstYearFreePricing =
    defaultcounty !== "EquityProtect"
      ? getObjLength(findTitleCompanyUser)
      : getObjLength(titleCompanyUser) && !isSignupCompleted;

  const isEnhancedMonitoring =
    category === "enhanced_monitoring" ? true : false;

  const resolvePromoCode = () => {
    if (carAgent || localStorage.getItem("car_portfolio_id")) {
      return null;
    }
    const fromStorage = localStorage.getItem("promoCode");
    if (fromStorage) {
      return fromStorage;
    }
    // Explicit promo prop (e.g. resume signup) is still allowed.
    if (promoCode) {
      return promoCode;
    }
    // Admin "Add Property" for an existing user: do not auto-apply their
    // stored default promo. Manual promo from Order Summary uses localStorage.
    if (from === "add-property") {
      return null;
    }
    if (selectedData?.userPromocode?.promocode_name) {
      return selectedData.userPromocode.promocode_name;
    }
    if (selectedUserData?.userPromocode?.promocode_name) {
      return selectedUserData.userPromocode.promocode_name;
    }
    return null;
  };

  let county_details =
    (getObjLength(selectedData) &&
      (selectedData?.owner?.[0]?.county_details ||
        selectedData?.[0]?.countyDetails ||
        selectedData?.county_details)) || //when user signup is incomplete
    (tabComponent && selectedUserData?.county_details) ||
    JSON.parse(localStorage.getItem("county_data"));

  const callPlansAPI = (county_data) => {
    const titleCompanyData = findAllowedPrefixData(county_data?.county_name);
    if (
      getObjLength(county_data) &&
      county_data?.id !== "ep" &&
      !titleCompanyData?.isFirstYearFreePricing &&
      // County plans have no Enhanced plan; county investors pay the standard one.
      !(isEnhancedMonitoring && selectedData?.county_user_id)
    ) {
      dispatch(
        userSigupAction.getSubscriptionPlan({
          url: `county/${county_data?.id}/get-plans`,
          data: { promo_code: resolvePromoCode() },
          type: "post",
        }),
      );
    } else {
      if (getObjLength(titleCompanyData) || getObjLength(titleCompanyUser)) {
        dispatch(
          brokerAgentsAction.getBrokerDetails({
            url: `get-broker-details/${
              (titleCompanyData || titleCompanyUser)?.prefix
            }?source=${(titleCompanyData || titleCompanyUser)?.source}`,
            data: {
              base_route: (titleCompanyData || titleCompanyUser)?.source,
            },
          }),
        );
      }
      if (!investorsID) {
        dispatch(
          userSigupAction.getSubscriptionPlan({
            url: "get-plans",
            data: { promo_code: resolvePromoCode() },
            type: "post",
          }),
        );
      }
    }
    setCountyListModal(false);
  };

  useEffect(() => {
    callPlansAPI(county_details);
    handleToggle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const handleNextButton = (data) => {
    setFinalAmount(totalPaymentDetails?.data);
    setDataFlag(false);
    setAlert(false);
    console.log("handleNextButton==>", data);
    localStorage.setItem(
      "planDetails",
      JSON.stringify({ plan_id: data?.plan_id, plan_Name: data?.name }),
    );
    planId(data?.plan_id);

    let params = {
      user_id: getObjLength(createAccResponse)
        ? createAccResponse.data?.user_id
        : userIdFromSession,
      step: 2,
      step_key: "GET_MAILING_ADDRESS",
    };
    if (from === "add-subscriptions" || from === "add-property") {
      params = {
        user_id: uid || selectedUserID,
        step: 2,
        step_key: "GET_MAILING_ADDRESS",
      };
    }

    dispatch(userSigupAction.fetchTotalPaymentDetails({}));
    if (
      isAdminCreateUser ||
      from === "add-subscriptions" ||
      from === "add-property"
    ) {
      dispatch(
        userSigupAction.getMailingAddress({
          url: "get-mailing-address",
          data: params,
        }),
      );
      dispatch(
        userSigupAction.getStateCode({ url: "get-states-code", data: {} }),
      );
    }

    onChangeModalScreen("cardsInfo");
  };

  const clearStoredPromoCode = () => {
    localStorage.removeItem("promoCode");
    try {
      const planData = JSON.parse(localStorage.getItem("Plan_Data") || "{}");
      if (planData?.promo_code != null) {
        const { promo_code: _removed, ...rest } = planData;
        localStorage.setItem("Plan_Data", JSON.stringify(rest));
      }
    } catch {
      // ignore invalid Plan_Data
    }
  };

  const closeFinalAmountPopup = (action) => {
    if (action === "cancel") {
      clearStoredPromoCode();
    }
    setAlert(false);
    setDataFlag(false);
    dispatch(userSigupAction.fetchTotalPaymentDetails({}));
  };

  // handle plan selection
  const handlePlanSelection = (plan) => {
    if (
      category === "enhanced_monitoring" &&
      isAdminEldoradoComplimentaryEnhancedSelected() &&
      from === "add-property"
    ) {
      let user_id = selectedUserID || uid;
      const fromSignupState = resolveEnhancedMonitoringReportIds({
        property_ids,
        propertyIds: signupPropertyIds,
      });
      const reportCandidates = [
        ...(Array.isArray(fromSignupState) ? fromSignupState : []),
        propertyQuestion?.data?.risk_report_id,
        propertyQuestion?.data?.report_id,
        propertyQuestion?.data?.id,
        selectedProperty?.risk_report_id,
        selectedProperty?.id,
      ]
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0);
      const riskReportIds = Array.from(new Set(reportCandidates));

      if (!user_id || !riskReportIds.length) {
        setComplimentaryEnrollResult({
          success: false,
          message:
            "Unable to activate Complimentary Enhanced Monitoring for this property. Please try again.",
        });
        return;
      }

      setSelectedPlan(plan);
      localStorage.setItem(
        "planDetails",
        JSON.stringify({ plan_id: plan?.plan_id, plan_Name: plan?.name }),
      );
      planId(plan?.plan_id);
      pendingComplimentaryEnhancedRef.current = true;
      setComplimentaryEnrollResult(null);
      dispatch(userSigupAction.fetchPaymentData({}));
      dispatch(
        userSigupAction.getPayment({
          url: "payment-enhanced-monitoring",
          data: {
            user_id,
            risk_report_id: riskReportIds,
            ...complimentaryEnhancedFreeFlagPayload(
              isLoggedInSuperOrInternalAdmin(userProfileDetails),
            ),
          },
          token: true,
        }),
      );
      return;
    }

    let pc = resolvePromoCode();
    let user_id =
      selectedUserID ||
      uid ||
      (getObjLength(createAccResponse)
        ? createAccResponse.data?.user_id
        : null) ||
      userIdFromSession ||
      userProfileDetails?.data?.user_id ||
      servicerProfessionalDetails?.data?.user_id;
    if (isAdminCreateUser) {
      user_id =
        selectedUserID ||
        uid ||
        (getObjLength(createAccResponse)
          ? createAccResponse.data?.user_id
          : null) ||
        userIdFromSession ||
        user_id;
    }
    if (from === "add-property") {
      user_id = selectedUserID || uid;
    }
    let data = {
      plan_id: parseInt(plan?.plan_id),
      user_id: user_id,
      property_id: [selectedProperty?.property_id],
      property_ids: [
        {
          address: selectedProperty?.address,
          property_id: selectedProperty?.property_id,
          city: selectedProperty?.city,
          state: selectedProperty?.state,
          zip: selectedProperty?.zip,
        },
      ],
      // state: selectedProperty?.json_response?.mm_fips_state_code,
    };

    if (from === "add-subscriptions") {
      data = {
        plan_id: parseInt(plan?.plan_id),
        user_id: uid,
        property_id: !tabComponent
          ? [selectedData?.property_id]
          : propertiesIds,
        property_ids: !tabComponent
          ? [
              {
                address: selectedData?.address,
                property_id: selectedData?.property_id,
                city: selectedData?.city,
                state: selectedData?.state,
                zip: selectedData?.zip,
              },
            ]
          : ids,
        // state: [selectedData?.state_code],
      };
    }
    if (pc?.length > 0) {
      data.promo_code = pc;
    }

    // Add Property quotes the property added in it (set above), not a list.
    if (
      fromPropertyList &&
      !isServicerAddPropertyCheckout({ isServiceProvider, from, selectedProperty })
    ) {
      data = {
        plan_id: parseInt(plan?.plan_id),
        user_id: user_id,
        property_id: propertyIds,
        property_ids: properties,
        // state: [selectedData?.state_code],
      };
    }

    if (
      userProfileDetails?.data?.user_type?.includes(ROLES?.professional) &&
      !userProfileDetails?.data?.role?.includes(ROLES?.customer)
    ) {
      if (!isEnhancedMonitoring) {
        data = attachEnhancedToCompleteUpgradeFlags(data, {
          property: selectedProperty || selectedData,
          propertyQuestion,
        });
      }
      Object.assign(data, carEnrollmentFields());
      const request = {
        url: "professional/get-final-amount",
        data,
        token: true,
      };
      setFinalAmountRequest(request);
      dispatch(userSigupAction.getTotalPaymentDetails(request));
    } else {
      const allowedPrefixObj = findAllowedPrefixData(defaultcounty);
      let url = "customer/get-final-amount";
      if (isEnhancedMonitoring) {
        url = `get-final-amount-enhanced-monitoring`;
      } else {
        url = mapCreateUserApiUrl(url, isServiceProvider);
      }
      if (isUserCreateProperty) {
        // url = "customer/get-final-amount-v1";

        data = {
          plan_id: parseInt(plan?.plan_id),
          user_id: decryptPayload(localStorage.getItem("roles"))?.includes(
            ROLES.serviceProvider,
          )
            ? user_id || servicerProfessionalDetails?.data?.user_id
            : user_id,
          property_id: [selectedProperty?.property_id],
          property_ids: [
            {
              address: selectedProperty?.address,
              property_id: selectedProperty?.property_id,
              state: selectedProperty?.state,
              city: selectedProperty?.city,
              zip: selectedProperty?.zip,
            },
          ],
        };
      } else {
        if (localStorage.getItem("promoCode")) {
          data = {
            ...data,
            promo_code: localStorage.getItem("promoCode"),
          };
        }
      }
      if (isAssistantAccount) {
        data = {
          ...data,
          promo_code: promoCode,
        };
      }
      if (
        from !== "add-property" &&
        getObjLength(allowedPrefixObj) &&
        allowedPrefixObj?.promoCode
      ) {
        data = {
          ...data,
          promo_code: allowedPrefixObj?.promoCode,
        };
      }
      if (!isEnhancedMonitoring) {
        data = attachEnhancedToCompleteUpgradeFlags(data, {
          property: selectedProperty || selectedData,
          propertyQuestion,
        });
      }
      Object.assign(data, carEnrollmentFields());
      const request = {
        url,
        data,
        ...(isServiceProvider ? { token: true } : {}),
      };
      setFinalAmountRequest(request);
      dispatch(userSigupAction.getTotalPaymentDetails(request));
    }
    localStorage.setItem(
      "Plan_Data",
      JSON.stringify({ ...data, state: selectedProperty?.state }),
    );
    localStorage.setItem("Plan_Name", JSON.stringify(plan?.name));
  };

  const servicerPlan = useMemo(() => {
    if (!getObjLength(subscriptionPlans) || !subscriptionPlans?.success) {
      return null;
    }
    return subscriptionPlans?.data?.find(
      (plan) => plan?.name === (isEnhancedMonitoring ? "Enhanced" : "Yearly"),
    );
  }, [isEnhancedMonitoring, subscriptionPlans]);

  const buildClientFinalAmountData = (plan) => {
    const clientUserId = isAdminCreateUser
      ? selectedUserID ||
        uid ||
        (getObjLength(createAccResponse)
          ? createAccResponse.data?.user_id
          : null) ||
        userIdFromSession
      : selectedUserID || uid;

    // Prefer every verified property already staged for this client (same as
    // card / fromPropertyList), not only the currently selected one. Add
    // Property quotes only the property added in it.
    const addPropertyCheckout = isServicerAddPropertyCheckout({
      isServiceProvider,
      from,
      selectedProperty,
    });
    const allPropertyIds =
      !addPropertyCheckout && Array.isArray(propertyIds)
        ? propertyIds.filter(Boolean)
        : [];
    const allPropertyRows =
      !addPropertyCheckout && Array.isArray(properties)
        ? properties.filter((row) => row?.property_id)
        : [];

    const resolvedPropertyIds =
      allPropertyIds.length > 0
        ? allPropertyIds
        : selectedProperty?.property_id
          ? [selectedProperty.property_id]
          : [];

    const resolvedPropertyRows =
      allPropertyRows.length > 0
        ? allPropertyRows.map((row) => ({
            address: row?.address,
            property_id: row?.property_id,
            city: row?.city,
            state: row?.state,
            zip: row?.zip,
          }))
        : selectedProperty?.property_id
          ? [
              {
                address: selectedProperty?.address,
                property_id: selectedProperty?.property_id,
                city: selectedProperty?.city,
                state: selectedProperty?.state,
                zip: selectedProperty?.zip,
              },
            ]
          : [];

    if (
      !plan?.plan_id ||
      !clientUserId ||
      resolvedPropertyIds.length === 0 ||
      resolvedPropertyRows.length === 0
    ) {
      return null;
    }

    const data = {
      plan_id: parseInt(plan.plan_id),
      user_id: clientUserId,
      property_id: resolvedPropertyIds,
      property_ids: resolvedPropertyRows,
    };

    const pc = resolvePromoCode();
    if (pc?.length > 0) {
      data.promo_code = pc;
    }

    return data;
  };

  // Quote the servicer's paid-at-closing option so the total reflects the POC
  // choice before the invoice is created.
  useEffect(() => {
    if (
      !servicerClosingEligible ||
      (!carAgent && !isPayingAtClosing(servicerPaymentChoice))
    ) {
      return undefined;
    }

    const data = buildClientFinalAmountData(servicerPlan);
    if (!data) {
      return undefined;
    }

    let cancelled = false;
    setClosingQuoteLoading(true);
    setClosingQuoteError("");

    postAPIPayload({
      url: mapCreateUserApiUrl("customer/get-final-amount", true),
      data: {
        ...data,
        payment_plan: carAgent ? carTerm : "paid_at_closing_5yr",
        ...(carAgent ? carEnrollmentFields() : {}),
        // POC only applies to Bill me at closing. The checkbox keeps its state
        // when the agent compares with Client pays now, but is not sent then.
        poc_recording:
          !postCloseCardOnly &&
          isPayingAtClosing(servicerPaymentChoice) &&
          pocRecording,
      },
      token: true,
    })
      .then((response) => {
        if (cancelled) {
          return;
        }
        if (response?.success) {
          setClosingQuote(response?.data);
          return;
        }
        setClosingQuoteError(
          response?.message ||
            response?.data?.message ||
            "Unable to price the paid-at-closing plan.",
        );
      })
      .catch((error) => {
        if (!cancelled) {
          setClosingQuoteError(
            error?.response?.data?.message ||
              error?.message ||
              "Unable to price the paid-at-closing plan.",
          );
        }
      })
      .finally(() => {
        if (!cancelled) {
          setClosingQuoteLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    createAccResponse,
    pocRecording,
    properties,
    propertyIds,
    selectedProperty?.property_id,
    selectedUserID,
    carAgent,
    carTerm,
    revenueChoice,
    servicerClosingEligible,
    servicerPaymentChoice,
    servicerPlan,
    uid,
  ]);

  const handleContinuePaidAtClosing = async (plan) => {
    if (readEnrollmentKind() === "post_close") {
      return;
    }
    const data = buildClientFinalAmountData(plan);
    if (!data || !getObjLength(closingQuote)) {
      return;
    }
    let prefill = {};
    try {
      prefill = JSON.parse(localStorage.getItem("carPortfolioPrefill") || "{}");
    } catch {
      prefill = {};
    }
    if (carAgent && prefill.enrollment_kind === "in_escrow") {
      const portfolioId = localStorage.getItem("car_portfolio_id");
      const quoteResponse = await postAPIPayload({
        url: `service-provider/car-portfolio/${portfolioId}/quote`,
        data: {
          payment_plan: carTerm,
          revenue_share_choice: revenueChoice,
          payment_timing: paymentTimingFor(servicerPaymentChoice),
        },
        token: true,
      });
      if (!quoteResponse?.success) {
        setClosingQuoteError(
          quoteResponse?.message || "Unable to save the payment choice.",
        );
        return;
      }
    }
    localStorage.setItem(
      "Plan_Data",
      JSON.stringify({ ...data, state: selectedProperty?.state }),
    );
    localStorage.setItem("Plan_Name", JSON.stringify(plan?.name));
    planId?.(plan?.plan_id);
    const quotedPlan =
      closingQuote?.payment_plan || (carAgent ? carTerm : "paid_at_closing_5yr");
    setFinalAmount?.({
      ...closingQuote,
      plan_id: plan?.plan_id,
      payment_plan: quotedPlan,
      revenue_share_choice:
        closingQuote?.revenue_share_choice || (carAgent ? revenueChoice : undefined),
    });
    if (carAgent) {
      localStorage.setItem(
        "carEnrollment",
        JSON.stringify({
          ...carEnrollmentFields(),
          payment_plan: quotedPlan,
          // The invoice screen words the agent- or buyer-paid invoice from this.
          payment_timing: paymentTimingFor(servicerPaymentChoice),
        }),
      );
    }
    onChangeModalScreen("paidAtClosing");
  };

  console.log(
    from,
    "plan data==>.",
    "==selectedData==",
    selectedData,
    "==selectedProperty===",
    selectedProperty,
  );

  useEffect(() => {
    if (!pendingComplimentaryEnhancedRef.current) {
      return;
    }
    if (paymnetLoader) {
      return;
    }
    if (!getObjLength(paymentData)) {
      return;
    }

    pendingComplimentaryEnhancedRef.current = false;
    if (paymentData?.success) {
      clearEldoradoAdminEnhancedBillingChoice();
      setComplimentaryEnrollResult({
        success: true,
        message:
          paymentData?.message ||
          paymentData?.data?.message ||
          "Complimentary Enhanced Monitoring activated for this El Dorado County property.",
      });
      return;
    }

    setComplimentaryEnrollResult({
      success: false,
      message:
        paymentData?.message ||
        paymentData?.data?.message ||
        "Unable to activate Complimentary Enhanced Monitoring.",
    });
  }, [paymentData, paymnetLoader]);

  useEffect(() => {
    if (Object.keys(subscriptionPlans).length > 0) {
      handleClose();
    }
  }, [subscriptionPlans]);

  useEffect(() => {
    dataflagRef.current = dataflag;
  }, [dataflag]);

  useEffect(() => {
    if (!getObjLength(totalPaymentDetails)) {
      return;
    }

    // Bill me at closing: Order Summary is for card checkout only — never
    // auto-open it on the payment-choice screen default load.
    if (
      servicerClosingEligible &&
      isPayingAtClosing(servicerPaymentChoice)
    ) {
      return;
    }

    if (totalPaymentDetails?.success) {
      // Quote already confirmed on the plan screen — keep inline pricing,
      // do not reopen the Order Summary modal after ownership verification.
      if (!finalAmountRequest) {
        return;
      }
      setAlert(true);
      setDataFlag(true);
      return;
    }

    const hadPromo = Boolean(
      finalAmountRequest?.data?.promo_code || localStorage.getItem("promoCode"),
    );

    // Order Summary already open → keep it so wrong-promo errors stay inline
    if (dataflagRef.current) {
      setAlert(true);
      setDataFlag(true);
      return;
    }

    // Initial load failed because of a bad promo → no error AlertDialog
    if (hadPromo) {
      clearStoredPromoCode();
      setAlert(false);
      setDataFlag(false);
      dispatch(userSigupAction.fetchTotalPaymentDetails({}));
      return;
    }

    setAlert(true);
    setDataFlag(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPaymentDetails, servicerClosingEligible, servicerPaymentChoice]);

  console.log(alert, "alert===Dataflag==", dataflag);

  // filter county
  const handleChoosePricing = (countyData) => {
    setDefaultCountyData(countyData?.county_domain_name);
    callPlansAPI(countyData);
  };

  const openCountyListModal = () => {
    setCountyListModal(true);
  };
  const IsAdmin =
    decryptPayload(localStorage.getItem("roles")) === ROLES?.admin ||
    decryptPayload(localStorage.getItem("roles")) === ROLES?.subAdmin;

  useEffect(() => {
    if (county_details) {
      setDefaultCountyData(county_details?.county_domain_name);
    }
    if (getObjLength(titleCompanyUser) && !isSignupCompleted) {
      setDefaultCountyData(titleCompanyUser?.prefix);
    }
  }, [selectedData]);

  return (
    <Box
      className={`${isAnualPlanScreen && "border_clasess"} ${
        !isAdminCreateUser && `bg-white`
      }`}
    >
      {(servicerClosingEligible ||
        (isTailwindComponent &&
          !investorsID &&
          !userProfileDetails?.data?.investor_id &&
          !userProfileDetails?.data?.county_user_id)) ? (
        <SubscriptionPlansTailwind
          subscriptionPlans={subscriptionPlans}
          isEnhancedMonitoring={isEnhancedMonitoring}
          isFirstYearFreePricing={isFirstYearFreePricing}
          isSignupCompleted={isSignupCompleted}
          onActivatePlan={(plan) => {
            setSelectedPlan(plan);
            handlePlanSelection(plan);
          }}
          showServicerPaymentChoice={
            servicerClosingEligible && !postCloseCardOnly
          }
          paymentChoice={servicerPaymentChoice}
          onPaymentChoiceChange={setServicerPaymentChoice}
          pocRecording={pocRecording}
          onPocRecordingChange={setPocRecording}
          closingQuote={closingQuote}
          closingQuoteLoading={closingQuoteLoading}
          closingQuoteError={closingQuoteError}
          onContinuePaidAtClosing={handleContinuePaidAtClosing}
          carEnabled={carAgent && servicerClosingEligible}
          carTerm={carTerm}
          onCarTermChange={setCarTerm}
          revenueChoice={revenueChoice}
          onRevenueChoiceChange={setRevenueChoice}
        />
      ) : (
        <>
          {isShow && (
            <Typography
              align="center"
              variant="subtitle1"
              className="py-1 formHeader zoom-container"
              sx={{ position: "relative" }}
            >
              <LockIcon sx={{ fontSize: 16 }} className="me-1" />
              Secure connection
              <Button
                onClick={handleCloseAddPropertyModal}
                className="modal-close-btn close-text hide-inner-close"
                style={{
                  position: "absolute",
                  top: 0,
                  right: -16,
                  background: "transparent",
                  textTransform: "none",
                }}
              >
                <CloseIcon
                  className="hide-inner-close"
                  sx={{ fontSize: 20, color: "white" }}
                />
              </Button>
            </Typography>
          )}

          <Box className="profile-wrapper plans-content-spacing subscription">
            {!investorsID &&
            !userProfileDetails?.data?.investor_id &&
            !userProfileDetails?.data?.county_user_id ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    // mb: 3,
                    my: 3,
                  }}
                >
                  {(!isAdminCreateUser || showSource) && (
                    <>
                      <Typography
                        sx={{ margin: "0 auto" }}
                        variant="h6"
                        className={`title ${IsAdmin && "mx-1"}`}
                      >
                        Subscriptions
                      </Typography>
                      {IsAdmin && category !== "enhanced_monitoring" && (
                        //&& !titleCompanyUser?.isFirstYearFreePricing
                        <Button
                          className="popup_Btn success_popup_btn"
                          onClick={openCountyListModal}
                        >
                          Source
                        </Button>
                      )}
                    </>
                  )}
                </Box>
                {/* left side box */}
                <Box className="market-value-second-box ">
                  <Grid
                    container
                    spacing={2}
                    className="justify-content-center"
                  >
                    {!isNormalCustomer &&
                      defaultcounty !== "EquityProtect" &&
                      (isFirstYearFreePricing || isAssistantAccount) && (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={6}
                          xl={6}
                          order={{ xs: 2, sm: 1, md: 1, lg: 1, xl: 1 }}
                        >
                          <Box
                            className="card"
                            height="100%"
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                          >
                            <Box
                              className={`d-flex align-items-center justify-content-between p-3 ${
                                (isFirstYearFreePricing ||
                                  isAssistantAccount) &&
                                "planCard title_card_spacing"
                              }`}
                            >
                              <SubscriptionPlansContent
                                plan1={true}
                                plan2={false}
                                fullPage={true}
                                onlyYearly={true}
                                county_name={
                                  defaultcounty !== "EquityProtect"
                                    ? defaultcounty
                                    : null
                                }
                                allowedPrefixObj={
                                  !isAssistantAccount ? {} : titleCompanyUser
                                }
                              />
                            </Box>

                            {!isFirstYearFreePricing && !isAssistantAccount && (
                              <Stack
                                direction="column"
                                alignItems="center"
                                className="py-3"
                              >
                                <Button
                                  variant="contained"
                                  className="popup_Btn success_popup_btn"
                                  onClick={() => {
                                    setSelectedPlan(
                                      subscriptionPlans?.data?.find(
                                        (data) => data?.name === "Monthly",
                                      ),
                                    );
                                    handlePlanSelection(
                                      subscriptionPlans?.data?.find(
                                        (data) => data?.name === "Monthly",
                                      ),
                                    );
                                    // handleNextButton(
                                    //   subscriptionPlans?.data?.find(
                                    //     (data) => data?.name === "Monthly"
                                    //   )
                                    // );
                                  }}
                                >
                                  Activate Plan
                                </Button>
                              </Stack>
                            )}
                          </Box>
                        </Grid>
                      )}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={6}
                      xl={6}
                      order={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
                    >
                      <Box
                        className="card"
                        height="100%"
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                      >
                        <Box
                          className={`d-flex align-items-center justify-content-between p-3 ${
                            (isFirstYearFreePricing || isAssistantAccount) &&
                            "planCard title_card_spacing"
                          }`}
                        >
                          <SubscriptionPlansContent
                            plan1={false}
                            plan2={true}
                            fullPage={true}
                            yearly_spacing={
                              defaultcounty === "EquityProtect"
                                ? "yearly_spacing"
                                : ""
                            }
                            is_temp_space={true}
                            county_name={
                              defaultcounty !== "EquityProtect"
                                ? defaultcounty
                                : null
                            }
                            allowedPrefixObj={
                              !isAssistantAccount ? {} : titleCompanyUser
                            }
                            isAdminCreateUser={isAdminCreateUser}
                            isEnhancedMonitoring={isEnhancedMonitoring}
                          />
                        </Box>

                        <Stack
                          direction="column"
                          alignItems="center"
                          className={isFirstYearFreePricing ? "pb-3" : "py-3"}
                        >
                          <Button
                            variant="contained"
                            className="popup_Btn success_popup_btn"
                            onClick={() => {
                              setSelectedPlan(
                                subscriptionPlans?.data?.find(
                                  (data) =>
                                    data?.name ===
                                    (isEnhancedMonitoring
                                      ? "Enhanced"
                                      : "Yearly"),
                                ),
                              );
                              handlePlanSelection(
                                subscriptionPlans?.data?.find(
                                  (data) =>
                                    data?.name ===
                                    (isEnhancedMonitoring
                                      ? "Enhanced"
                                      : "Yearly"),
                                ),
                              );
                              // handleNextButton(
                              //   subscriptionPlans?.data?.find(
                              //     (data) => data?.name === "Yearly"
                              //   )
                              // );
                            }}
                          >
                            {isFirstYearFreePricing && !isSignupCompleted
                              ? "Complete Registration"
                              : "Activate Plan"}
                          </Button>
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </>
            ) : (
              <InvestorsAnnaulSubscriptionPlan
                uid={uid}
                paySecure={handleNextButton}
                propertiesIds={
                  from === "add-property" || isUserCreateProperty
                    ? [selectedProperty?.property_id]
                    : isBulkSubscription
                      ? ids?.map((id) => id?.property_id)
                      : !tabComponent
                        ? [selectedData?.property_id]
                        : propertiesIds
                }
                tabComponent={tabComponent}
                selectedData={
                  getObjLength(selectedProperty)
                    ? selectedProperty
                    : getObjLength(selectedData)
                      ? selectedData
                      : undefined
                }
                promoCode={promoCode}
              />
            )}
          </Box>

          {!isTailwindComponent && (
            <section className="plans-content-spacing">
              <Container fluid>
                <SubscriptionPlansFeatures
                  fullPage={true}
                  plans_title="All plans include"
                />
              </Container>
            </section>
          )}
        </>
      )}

      {alert &&
        (dataflag ? (
          <TotalPyamentPopup
            dataflag={dataflag}
            setDataFlag={setDataFlag}
            alert={alert}
            setAlert={setAlert}
            closePopup={closeFinalAmountPopup}
            planDetails={selectedPlan}
            isClose={false}
            paySecure={() => handleNextButton(selectedPlan)}
            hideRecordingFees={
              getObjLength(titleCompanyUser) && !isSignupCompleted
            }
            isTailwindComponent={isTailwindComponent}
            showPromoCode={isTailwindComponent && !carAgent}
            finalAmountRequest={finalAmountRequest}
          />
        ) : (
          <>
            <AlertDialog
              isTailwindComponent={isTailwindComponent}
              type="Error"
              openPopup={alert}
              onClose={true}
              onCloseFun={() => closeFinalAmountPopup("cancel")}
              mesage={totalPaymentDetails?.data?.message}
              buttons={
                <Stack spacing={2} direction={"row"} justifyContent={"center"}>
                  <Button
                    className="popup_Btn error_popup_btn m-2"
                    onClick={() => closeFinalAmountPopup("cancel")}
                  >
                    cancel
                  </Button>
                </Stack>
              }
            />
          </>
        ))}

      <DialogBox
        fullScreenModal={false}
        width={"sm"}
        contentClassName={"bg-white"}
        title={"Select the Source for Pricing"}
        openPopup={countyListModal}
        onClose={() => {
          setCountyListModal(false);
        }}
        content={
          <CountyListDropDown
            handleCountyData={handleChoosePricing}
            hideEPFromList={false}
            defaultcounty={defaultcounty}
          />
        }
      />

      {complimentaryEnrollResult ? (
        <AlertDialog
          isTailwindComponent={isTailwindComponent}
          type={complimentaryEnrollResult.success ? "Success" : "Error"}
          openPopup={true}
          onClose={true}
          onCloseFun={() => {
            const succeeded = complimentaryEnrollResult.success;
            setComplimentaryEnrollResult(null);
            dispatch(userSigupAction.fetchPaymentData({}));
            if (succeeded) {
              handleCloseAddPropertyModal?.("success");
            }
          }}
          mesage={complimentaryEnrollResult.message}
          footer={false}
        />
      ) : null}
      <Loader open={statesLoader || getTotalAmountLoader} />
    </Box>
  );
};

export default SubscriptionPlans;
